export enum HawkEvents {
  HAWK_PROCESS_NOVA_WIDGET = 'HAWK_PROCESS_NOVA_WIDGET',
  HAWK_PROCESS_ARTICLE = 'processArticle',
  KIOSQ_COOKIE_CHANGE = 'KiosqCookieChange',
}
